//Languages constant
export const languages = {
  ARABIC: 'ar',
  BENGALI: 'bn',
  BULGARIAN: 'bg',
  CHINESE: 'zh',
  SIMPLIFIED_CHINESE: 'zh-cn',
  CZECH: 'cs',
  DUTCH: 'nl',
  ENGLISH: 'en',
  FRENCH: 'fr',
  FRENCH_CANADIAN: 'fr-ca',
  GERMAN: 'de',
  GUJARATI: 'gu',
  HINDI: 'hi',
  HUNGARIAN: 'hu',
  INDONESIAN: 'id',
  ITALIAN: 'it',
  JAPANESE: 'ja',
  JAVANESE: 'jv',
  KOREAN: 'ko',
  MALAY: 'ms',
  MARATHI: 'mr',
  NORWEGIAN: 'no',
  PERSIAN: 'fa',
  POLISH: 'pl',
  PORTUGUESE: 'pt',
  PUNJABI: 'pa',
  ROMANIAN: 'ro',
  RUSSIAN: 'ru',
  SINHALA: 'si',
  SLOVAK: 'sk',
  SLOVENIAN: 'sl',
  SPANISH: 'es',
  SWEDISH: 'sv',
  TAGALOG: 'tl',
  TAMIL: 'ta',
  TELUGU: 'te',
  THAI: 'th',
  TURKISH: 'tr',
  UKRAINIAN: 'uk',
  URDU: 'ur',
  VIETNAMESE: 'vi',
}

//Language options
export const languageOptions = [
  {
    value: languages.ENGLISH,
    label: 'English',
  },
  {
    value: languages.ARABIC,
    label: 'العربية (Arabic)',
  },
  {
    value: languages.BENGALI,
    label: 'বাংলা (Bengali)',
  },
  {
    value: languages.BULGARIAN,
    label: 'Български (Bulgarian)',
  },
  {
    value: languages.CHINESE,
    label: '繁體中文 (Traditional Chinese)',
  },
  {
    value: languages.SIMPLIFIED_CHINESE,
    label: '简体中文 (Simplified Chinese)',
  },
  {
    value: languages.CZECH,
    label: 'Čeština (Czech)',
  },
  {
    value: languages.DUTCH,
    label: 'Nederlands (Dutch)',
  },
  {
    value: languages.FRENCH,
    label: 'Français (French)',
  },
  {
    value: languages.FRENCH_CANADIAN,
    label: 'Français (Canada)',
  },
  {
    value: languages.GERMAN,
    label: 'Deutsch (German)',
  },
  {
    value: languages.GUJARATI,
    label: 'ગુજરાતી (Gujarati)',
  },
  {
    value: languages.HINDI,
    label: 'हिंदी (Hindi)',
  },
  {
    value: languages.HUNGARIAN,
    label: 'Magyar (Hungarian)',
  },
  {
    value: languages.INDONESIAN,
    label: 'Bahasa Indonesia (Indonesian)',
  },
  {
    value: languages.ITALIAN,
    label: 'Italiano (Italian)',
  },
  {
    value: languages.JAPANESE,
    label: '日本語 (Japanese)',
  },
  {
    value: languages.JAVANESE,
    label: 'ꦧꦱꦗꦮ (Javanese)',
  },
  {
    value: languages.KOREAN,
    label: '한국어 (Korean)',
  },
  {
    value: languages.MALAY,
    label: 'Bahasa Melayu (Malay)',
  },
  {
    value: languages.MARATHI,
    label: 'मराठी (Marathi)',
  },
  {
    value: languages.NORWEGIAN,
    label: 'Norsk (Norwegian)',
  },
  {
    value: languages.PERSIAN,
    label: 'فارسی (Persian)',
  },
  {
    value: languages.POLISH,
    label: 'Polski (Polish)',
  },
  {
    value: languages.PORTUGUESE,
    label: 'Português (Portuguese)',
  },
  {
    value: languages.PUNJABI,
    label: 'ਪੰਜਾਬੀ (Punjabi)',
  },
  {
    value: languages.ROMANIAN,
    label: 'Română (Romanian)',
  },
  {
    value: languages.RUSSIAN,
    label: 'Русский (Russian)',
  },
  {
    value: languages.SINHALA,
    label: 'සිංහල (Sinhala)',
  },
  {
    value: languages.SLOVAK,
    label: 'Slovenčina (Slovak)',
  },
  {
    value: languages.SLOVENIAN,
    label: 'Slovenščina (Slovenian)',
  },
  {
    value: languages.SPANISH,
    label: 'Español (Spanish)',
  },
  {
    value: languages.SWEDISH,
    label: 'Svenska (Swedish)',
  },
  {
    value: languages.TAGALOG,
    label: 'Filipino (Tagalog)',
  },
  {
    value: languages.TAMIL,
    label: 'தமிழ் (Tamil)',
  },
  {
    value: languages.TELUGU,
    label: 'తెలుగు (Telugu)',
  },
  {
    value: languages.THAI,
    label: 'ไทย (Thai)',
  },
  {
    value: languages.TURKISH,
    label: 'Türkçe (Turkish)',
  },
  {
    value: languages.UKRAINIAN,
    label: 'Українська (Ukrainian)',
  },
  {
    value: languages.URDU,
    label: 'اردو (Urdu)',
  },
  {
    value: languages.VIETNAMESE,
    label: 'Tiếng Việt (Vietnamese)',
  },
]

//Coats specific subset of language codes
const coatsLanguageCodes = [
  languages.ENGLISH,
  languages.SIMPLIFIED_CHINESE,
  languages.SPANISH,
  languages.VIETNAMESE,
  languages.INDONESIAN,
  languages.ARABIC,
  languages.TURKISH,
  languages.HUNGARIAN,
  languages.GERMAN,
  languages.ROMANIAN,
  languages.THAI,
  languages.URDU,
  languages.ITALIAN,
  languages.FRENCH,
  languages.POLISH,
]

//Coats specific language options (filtered from the full list)
export const coatsLanguageOptions = languageOptions
  .filter(option => coatsLanguageCodes.includes(option.value))
